import { twMerge } from 'tailwind-merge';

type Props = {
  children?: React.ReactNode;
  className?: string;
};

function QueueTable({ className, children }: Props): React.ReactElement {
  const classNames = twMerge('w-full mt-6 border-separate border-spacing-y-1', className);

  return <table className={classNames}>{children}</table>;
}

function TableHeader({ className, children }: Props): React.ReactElement {
  const classNames = twMerge(
    'antialiased text-left font-thin font-aribau text-zinc-400 text-xs',
    className,
  );

  return (
    <thead className={classNames}>
      <tr>{children}</tr>
    </thead>
  );
}

function TableHead({ className, children }: Props): React.ReactElement {
  const classNames = twMerge('pb-2 px-3', className);

  return <th className={classNames}>{children}</th>;
}

function TableCell({ children, className }: Props): React.ReactElement {
  const classNames = twMerge('p-3', className);

  return <td className={classNames}>{children}</td>;
}

export default {
  Table: QueueTable,
  THead: TableHead,
  TableHeader: TableHeader,
  TableCell,
};
